import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    title: null,
    date: null,
    startTime: null,
    endTime: null,
    mode: "online",
    modeType: null,
    groupIds: [],
    brandId: null,
    entityType: [],
    courseId: [],
    privacy: [],
    invite: false,
    description: null,
    repeatEvents: false,
    repeatEvent: { frequency: "never", repeatStartTime: null, repeatEndTime: null, frequencyEndDate: null },
    publisherId: null,
    eventLink: null,
    hostId: null,
    thumbnail: "",
    session: 1,
    status: "upcoming",
    sendInvite: true,
    typeStream: "nolive",
    status:false,
    recordingLink:'',
    platformTypes:[]
  },
};

export const eventSlice = createSlice({
  name: "eventSlice",
  initialState,
  reducers: {
    setEventData: (state, { payload }) => {
      state.data = payload
    },
    resetEvent: () => initialState
  },
});

export const { resetEvent, setEventData } = eventSlice.actions;

export default eventSlice.reducer;
